var map = {
	"./BaseAlert.vue": "./src/global/BaseAlert.vue",
	"./BaseAppLogo.vue": "./src/global/BaseAppLogo.vue",
	"./BaseAudioPlayer.vue": "./src/global/BaseAudioPlayer.vue",
	"./BaseAutocomplete.vue": "./src/global/BaseAutocomplete.vue",
	"./BaseBookPicker.vue": "./src/global/BaseBookPicker.vue",
	"./BaseButton.vue": "./src/global/BaseButton.vue",
	"./BaseColorPicker.vue": "./src/global/BaseColorPicker.vue",
	"./BaseComposeEmailDialog.vue": "./src/global/BaseComposeEmailDialog.vue",
	"./BaseComposeNotifyDialog.vue": "./src/global/BaseComposeNotifyDialog.vue",
	"./BaseConfirm.vue": "./src/global/BaseConfirm.vue",
	"./BaseConfirmSupport.vue": "./src/global/BaseConfirmSupport.vue",
	"./BaseCourseOfflinePicker.vue": "./src/global/BaseCourseOfflinePicker.vue",
	"./BaseCoursePicker.vue": "./src/global/BaseCoursePicker.vue",
	"./BaseDatePicker.vue": "./src/global/BaseDatePicker.vue",
	"./BaseDelete.vue": "./src/global/BaseDelete.vue",
	"./BaseDropdown.vue": "./src/global/BaseDropdown.vue",
	"./BaseEditor.vue": "./src/global/BaseEditor.vue",
	"./BaseEmptyData.vue": "./src/global/BaseEmptyData.vue",
	"./BaseEventPicker.vue": "./src/global/BaseEventPicker.vue",
	"./BaseExcelActionList.vue": "./src/global/BaseExcelActionList.vue",
	"./BaseExcelStyleExport.vue": "./src/global/BaseExcelStyleExport.vue",
	"./BaseFileName.vue": "./src/global/BaseFileName.vue",
	"./BaseGroupPicker.vue": "./src/global/BaseGroupPicker.vue",
	"./BaseHLSVideoPlayer.vue": "./src/global/BaseHLSVideoPlayer.vue",
	"./BaseHomeworkArchiver.vue": "./src/global/BaseHomeworkArchiver.vue",
	"./BaseImageThumbnail.vue": "./src/global/BaseImageThumbnail.vue",
	"./BaseInput.vue": "./src/global/BaseInput.vue",
	"./BaseInputRequired.vue": "./src/global/BaseInputRequired.vue",
	"./BaseInputSearch.vue": "./src/global/BaseInputSearch.vue",
	"./BaseLearningPathPicker.vue": "./src/global/BaseLearningPathPicker.vue",
	"./BaseLoading.vue": "./src/global/BaseLoading.vue",
	"./BaseLoadingAllScreen.vue": "./src/global/BaseLoadingAllScreen.vue",
	"./BaseMessage.vue": "./src/global/BaseMessage.vue",
	"./BaseMultipleDropdown.vue": "./src/global/BaseMultipleDropdown.vue",
	"./BaseOfficeViewer.vue": "./src/global/BaseOfficeViewer.vue",
	"./BasePDFQuestionRenderer.vue": "./src/global/BasePDFQuestionRenderer.vue",
	"./BasePDFRenderExam.vue": "./src/global/BasePDFRenderExam.vue",
	"./BasePDFRenderExamReview.vue": "./src/global/BasePDFRenderExamReview.vue",
	"./BasePDFViewer.vue": "./src/global/BasePDFViewer.vue",
	"./BasePopupEditor.vue": "./src/global/BasePopupEditor.vue",
	"./BaseProgressBar.vue": "./src/global/BaseProgressBar.vue",
	"./BaseRadioGroup.vue": "./src/global/BaseRadioGroup.vue",
	"./BaseResourceAutoComplete.vue": "./src/global/BaseResourceAutoComplete.vue",
	"./BaseSelectUploadResource.vue": "./src/global/BaseSelectUploadResource.vue",
	"./BaseSendEmailDialog.vue": "./src/global/BaseSendEmailDialog.vue",
	"./BaseSendNotificationDialog.vue": "./src/global/BaseSendNotificationDialog.vue",
	"./BaseServerError.vue": "./src/global/BaseServerError.vue",
	"./BaseTeacherPicker.vue": "./src/global/BaseTeacherPicker.vue",
	"./BaseTextArea.vue": "./src/global/BaseTextArea.vue",
	"./BaseTextAreaHtml.vue": "./src/global/BaseTextAreaHtml.vue",
	"./BaseTimePicker.vue": "./src/global/BaseTimePicker.vue",
	"./BaseTitleTable.vue": "./src/global/BaseTitleTable.vue",
	"./BaseTooltipWithIcon.vue": "./src/global/BaseTooltipWithIcon.vue",
	"./BaseTopicWithChildren.vue": "./src/global/BaseTopicWithChildren.vue",
	"./BaseTreeSelectTopic.vue": "./src/global/BaseTreeSelectTopic.vue",
	"./BaseUpload.vue": "./src/global/BaseUpload.vue",
	"./BaseUploadDragger.vue": "./src/global/BaseUploadDragger.vue",
	"./BaseUploadDraggerList.vue": "./src/global/BaseUploadDraggerList.vue",
	"./BaseUploadFile.vue": "./src/global/BaseUploadFile.vue",
	"./BaseUploadImage.vue": "./src/global/BaseUploadImage.vue",
	"./BaseUploadWithButton.vue": "./src/global/BaseUploadWithButton.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/global sync [\\w-]+\\.vue$";